import { ILetterSpacing } from '../types';

export const letterSpacing: ILetterSpacing = {
  headings: {
    H1: '-2px',
    H2: '-1.5px',
    H3: '-1px',
    H4: '-0.5px',
    H5: 'normal',
    H6: 'normal',
  },
  button: 'normal',
  body: 'normal',
  overline: '1px',
};
